{
  "Accessibility Menu": "Tilgængelighedsmenu",
  "Reset settings": "Nulstil indstillinger",
  "Close": "Luk",
  "Content Adjustments": "Justeringer af indhold",
  "Adjust Font Size": "Juster skriftstørrelse",
  "Highlight Title": "Fremhæv titel",
  "Highlight Links": "Fremhæv links",
  "Readable Font": "Læsbar skrifttype",
  "Color Adjustments": "Farvejusteringer",
  "Dark Contrast": "Mørk kontrast",
  "Light Contrast": "Lys kontrast",
  "High Contrast": "Høj kontrast",
  "High Saturation": "Høj mætning",
  "Low Saturation": "Lav mætning",
  "Monochrome": "Monokrom",
  "Tools": "Værktøjer",
  "Reading Guide": "Læsevejledning",
  "Stop Animations": "Stop animationer",
  "Big Cursor": "Stor markør",
  "Increase Font Size": "Øg skriftstørrelse",
  "Decrease Font Size": "Formindsk skriftstørrelse",
  "Letter Spacing": "Bogstavafstand",
  "Line Height": "Linjehøjde",
  "Font Weight": "Skrifttypevægt",
  "Dyslexia Font": "Ordblinde-skrifttype",
  "Language": "Sprog",
  "Open Accessibility Menu": "Åbn tilgængelighedsmenu",
  "Accessibility Profiles": "Tilgængelighedsprofiler",
  "Seizure Safe Profile": "Epilepsisikker profil",
  "Stops animations and reduces color saturation.": "Stopper animationer og reducerer farvemætning.",
  "Blind Profile": "Blind profil",
  "Activates the screen reader for auditory navigation.": "Aktiverer skærmlæser til auditiv navigation.",
  "Visually Impaired Profile": "Synshandicappet profil",
  "Enhances contrast and readability for low vision.": "Forbedrer kontrast og læsbarhed for svagt syn.",
  "ADHD Friendly Profile": "ADHD-venlig profil",
  "Reduces distractions for better focus.": "Reducerer distraktioner for bedre fokus.",
  "Cognitive & Learning Profile": "Kognitiv & læringsprofil",
  "Helpful tools for reading and comprehension.": "Hjælpsomme værktøjer til læsning og forståelse.",
  "Motor Impaired Profile": "Motorisk handikappet profil",
  "Optimizes the site for keyboard-only navigation.": "Optimerer webstedet til navigation kun med tastatur.",
  "Headings": "Overskrifter",
  "Landmarks": "Landemærker",
  "Links": "Links",
  "Focus element": "Fokuselement",
  "Visit link": "Besøg link"
}